// * Ensures that callback occurs after dom paint has completed
// * https://stackoverflow.com/a/34999925/1514572
export function onNextFrame(callback) {
    setTimeout(function () {
        requestAnimationFrame(callback);
    });
}
//# sourceMappingURL=onNextFrame.js.map